import { useRef } from 'react'
import { Box, BoxProps, Flex } from 'theme-ui'

export type NavProps = BoxProps & {
  Heading: JSX.Element
  Search?: JSX.Element | null
  Content?: JSX.Element | null
}

export function NavTemplate({
  Heading,
  Search = null,
  Content = null,
  ...rest
}: NavProps) {
  const navbarRef = useRef<HTMLDivElement>(null)
  return (
    <Box
      as="header"
      id="Nav"
      ref={navbarRef}
      bg="primary"
      sx={{
        position: 'relative',
        py: 3,
        px: 5,
      }}
      {...rest}>
      <Flex
        margin="auto"
        sx={{
          flex: 1,
          alignItems: 'center',
          justifyContent: 'space-between',
          flexDirection: 'row',
          display: 'flex',
          maxWidth: 1440,
          textAlign: 'center',
        }}
        className={`NavTemplate-menu`}>
        {/* Title */}
        <Flex
          sx={{
            alignItems: 'center',
            minHeight: '80px',
            textAlign: 'left',
            width: ['80%', '30%'],
            pr: '10px',
          }}>
          {Heading}
        </Flex>
        {/* Navigation */}
        {Content ?? null}
      </Flex>
    </Box>
  )
}
